var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"footer-button",class:{
    enabled: _vm.enabled,
    isPC: _vm.$store.getters['camera/isPC'],
    isPaidy: _vm.$store.getters['auth/isPaidy'],
    [_vm.color]: _vm.color,
    flex: _vm.flex
  },attrs:{"tabindex":_vm.enabled ? 0 : -1},on:{"click":_vm.onClick}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }